import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import RegisterPage from '../pages/Auth/RegisterPage';
import UserPage from '../pages/Auth/UserPage';
import LoginPage from '../pages/Auth/LoginPage';
import ForgotPasswordPage from '../pages/Auth/forgotPasswordPage';
import ValidateCodePage from '../pages/Auth/ValidateCodePage';
import ResetPasswordPage from '../pages/Auth/ResetPasswordPage';
import RegisterManualStep1 from '../pages/Auth/RegisterManualStep1';
import RegisterManualStep2 from '../pages/Auth/RegisterManualStep2';


const AuthRoutes = () => (
  <Routes>
    <Route path="/register" element={<RegisterPage />} />
    <Route path="/register-manual/step-1" element={<RegisterManualStep1 />} />
    <Route path="/register-manual/step-2" element={<RegisterManualStep2 />} />
    <Route path="/user" element={<UserPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
    <Route path="/validate-code" element={<ValidateCodePage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
  </Routes>
);

export default AuthRoutes;